import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../../../hooks/useQueryParams";

const FILTER_OPTIONS = [
  {
    id: "true",
    name: "Active",
  },
  {
    id: "false",
    name: "Deactivated",
  },
];

export function StatusFilter() {
  const { setParam, params } = useQueryParams();
  const { t } = useTranslation();

  return (
    <Picker
      showActionBar
      selectedKeys={params.is_active?.split(",") || []}
      onSelectionChange={(keys) => setParam("is_active", Array.from(keys))}
      label={t("Status")}
      items={FILTER_OPTIONS}
      selectionMode="single"
      testID="status-filter"
    />
  );
}
